import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { UserService } from '@shared/services/user.service';
import { ModalController, ToastController } from '@ionic/angular';
import { AnalyticsService } from './analytics.service';
import { Preferences } from '@capacitor/preferences';

@Injectable({
  providedIn: 'root'
})
export class CoinService {
  private userData : any;
  constructor(public http: HttpClient, 
    private userService:UserService,
    public toastCtrl: ToastController,
    public modalCtrl: ModalController,
    private analytics: AnalyticsService) {
      console.log('Hello CoinServiceProvider Provider');

      Preferences.get({key:'USER_DATA'}).then((val) => {
        val =val.value ? JSON.parse(val.value) : null;
        this.userData = val;
      })



}

  public getCount(): number {
    if(this.userData != null && this.userData?.coins != null){
      return this.userData?.coins;
    }else{
      return 0;
    }
  }

  public checkUserHasCoins(localUserData : any, origin:any) : boolean {
    this.userData = localUserData;
    if(this.userData.coins == null || this.userData.coins == 0){
      // Needs to buy
      //this.openStore(origin);
      return false;
    }else{
      return true;      
    }
  }

  private openStore(origin:any){
    
    this.analytics.registerEvent(AnalyticsService.carrots);
    this.analytics.registerEvent(AnalyticsService.crrtFromSuperlike);

  }
}
